<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
              <br />
              <!--dialog shifts -->
              <div>
                <v-row justify="center">
                  <v-dialog v-model="dialogForm" fullscreen persistent>
                    <v-toolbar color="indigo" dark>
                      <v-toolbar-title>สลับกะ</v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn icon @click="dialogForm = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card>
                      <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="basil"
                        grow
                      >
                        <v-tab
                          href="#shift_friend"
                          class="primary--text"
                          @click="clearForm()"
                        >
                          แลกกะกับเพื่อน
                        </v-tab>

                        <v-tab
                          href="#shift_self"
                          class="primary--text"
                          @click="clearForm()"
                        >
                          สลับวันหยุด
                        </v-tab>
                        <v-tab
                          href="#shift"
                          class="primary--text"
                          @click="clearForm()"
                        >
                          เปลี่ยนกะ
                        </v-tab>

                        <v-tab-item value="shift_friend">
                          <v-simple-table>
                            <center>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="item_Info.masShiftTypeNameDay"
                                  label="กะ ตัวเอง"
                                  prepend-icon="mdi-message-text"
                                  disabled
                                  outlined
                                  readonly
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="form.empCodeFriend"
                                  :items="dataItemTeam"
                                  label="ชื่อ เพื่อน"
                                  prepend-icon="mdi-message-text"
                                  @change="
                                    getDataShiftFriend(form.empCodeFriend)
                                  "
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12" v-if="form.empCodeFriend">
                                <v-select
                                  v-model="form.shiftTransferNewShiftCode"
                                  :items="dataItemShiftsFriend"
                                  prepend-icon="mdi-message-text"
                                  label="กะ เพื่อน"
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  rows="3"
                                  row-height="25"
                                  outlined
                                  prepend-icon="mdi-message-text"
                                  :rules="nameRules"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  label="รายละเอียดสลับกะ"
                                  v-model="form.shiftTransferRemark"
                                ></v-textarea>
                              </v-col>
                            </center>
                            <v-col class="text-right">
                              <v-btn
                                v-if="
                                  form.shiftTransferNewShiftCode !== null &&
                                  form.empCodeFriend !== null
                                "
                                depressed
                                color="primary"
                                @click="
                                  (dialogForm = false),
                                    saveShift('friend', form)
                                "
                              >
                                ยืนยัน
                              </v-btn>
                            </v-col>
                          </v-simple-table>
                        </v-tab-item>

                        <v-tab-item value="shift_self">
                          <v-simple-table>
                            <center>
                              <!-- {{dataShiftSelf}} -->
                              <v-col cols="12">
                                <v-text-field
                                  v-model="item_Info.masShiftTypeNameDay"
                                  label="กะ ตัวเอง"
                                  prepend-icon="mdi-message-text"
                                  disabled
                                  outlined
                                  readonly
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="form.shiftTransferNewShiftCode"
                                  :items="dataShiftSelf"
                                  prepend-icon="mdi-message-text"
                                  label="กะ"
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="form.shiftTransferNewShiftCode"
                                  :items="dataMasShift"
                                  prepend-icon="mdi-message-text"
                                  label="เปลี่ยนกะ"
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  rows="3"
                                  row-height="25"
                                  outlined
                                  prepend-icon="mdi-message-text"
                                  :rules="nameRules"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  label="รายละเอียดสลับกะ"
                                  v-model="form.shiftTransferRemark"
                                ></v-textarea>
                              </v-col>
                            </center>
                            <v-col class="text-right">
                              <v-btn
                                v-if="
                                  dataShiftSelf.length > 0 &&
                                  form.shiftTransferRemark !== null &&
                                  form.shiftTransferNewShiftCode !== null
                                "
                                depressed
                                color="primary"
                                @click="
                                  (dialogForm = false), saveShift('self', form)
                                "
                              >
                                ยืนยัน
                              </v-btn>
                            </v-col>
                          </v-simple-table>
                        </v-tab-item>
                        <!-- mas shift -->
                        <v-tab-item value="shift">
                          <v-simple-table>
                            <center>
                              <!-- {{dataShiftSelf}} -->
                              <v-col cols="12">
                                <v-text-field
                                  v-model="item_Info.masShiftTypeNameDay"
                                  label="กะ ตัวเอง"
                                  prepend-icon="mdi-message-text"
                                  disabled
                                  outlined
                                  readonly
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="form.shiftTransferNewShiftCode"
                                  :items="dataMasShift"
                                  prepend-icon="mdi-message-text"
                                  label="กะ"
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  rows="3"
                                  row-height="25"
                                  outlined
                                  prepend-icon="mdi-message-text"
                                  :rules="nameRules"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  label="รายละเอียดสลับกะ"
                                  v-model="form.shiftTransferRemark"
                                ></v-textarea>
                              </v-col>
                            </center>
                            <v-col class="text-right">
                              <v-btn
                                v-if="
                                  dataMasShift.length > 0 &&
                                  form.shiftTransferRemark !== null &&
                                  form.shiftTransferNewShiftCode !== null
                                "
                                depressed
                                color="primary"
                                @click="
                                  saveShift('shift', form), (dialogForm = false)
                                "
                              >
                                ยืนยัน
                              </v-btn>
                            </v-col>
                          </v-simple-table>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>
                  </v-dialog>
                </v-row>
              </div>
            </v-card>

            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#list1" class="primary--text"> รายการ </v-tab>
              <v-tab href="#history" class="primary--text"> ประวัติ </v-tab>
              <v-tab
                href="#request"
                class="primary--text"
                v-if="dataICountItemFriendApprove > 0"
              >
                คำขอ
                <v-badge
                  v-if="dataICountItemFriendApprove > 0"
                  color="red"
                  :content="dataICountItemFriendApprove"
                >
                </v-badge>
              </v-tab>
              <v-tab
                href="#header"
                class="primary--text"
                v-if="profile.positionLevelOrderNumber !== '1'"
                @click="getDataHeaderApproveWaiting()"
              >
                อนุมัติ
                <v-badge
                  v-if="dataICountItemApprove > 0"
                  color="red"
                  :content="dataICountItemApprove"
                >
                </v-badge>
              </v-tab>
              <v-tab
                href="#verifyheader"
                class="primary--text"
                v-if="profile.positionLevelOrderNumber !== '1'"
                @click="getDataSubHeaderApproveWaiting()"
              >
                รับทราบ
                <v-badge
                  v-if="dataICountItemApproveSub > 0"
                  color="red"
                  :content="dataICountItemApproveSub"
                >
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="list1">
                <v-expansion-panels v-model="panel1" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel1" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            label="เดือน"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปี"
                            class="ma-2"
                          ></v-select>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getDataShift(month)"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">วัน</th>
                        <th class="text-center">ประเภทกะ</th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(items, index) in dataItemShift" :key="index">
                        <td>
                          {{ items.shiftDay }}
                        </td>
                        <td>
                          {{ items.masShiftTypeName }}
                        </td>
                        <td>
                          <v-btn
                            v-if="items.tranfer_request === 'waiting'"
                            color="gray"
                            class="ma-2"
                            dark
                          >
                            กำลังดำเนินการ
                          </v-btn>
                          <v-btn
                            v-if="
                              items.tranfer_request !== 'waiting' &&
                              items.shiftDate >= currentMorDay
                            "
                            color="primary"
                            class="ma-2"
                            dark
                            @click="(dialogForm = true), itemInfo(items)"
                          >
                            สลับกะ
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="history">
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="shiftTypeSearch"
                            :items="itemsShiftType"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="ประเภทสลับกะ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="ShiftTransferStatusSearch"
                            :items="itemShiftTransferAppoveStatus"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="สถานะอนุมัติ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือน"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปี"
                            class="ma-2"
                          ></v-select>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="getDataShiftTransfer()"
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">ประวัติการสลับกะ</th>
                        <th class="text-center">สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dataItemShiftTransfer"
                        :key="item.shiftTransferId"
                      >
                        <td>
                          ประเภท : <b>{{ item.shiftTransferTypeName }}</b>
                          <br />
                          <template v-if="item.empFull_NameTH_Friend"
                            >เพื่อน : {{ item.empFull_NameTH_Friend }} ({{
                              item.shiftTransferFriendAppoveStatus
                            }})<br
                          /></template>
                          กะ: <b>{{ item.shiftTransferOldShiftCodeName }}</b
                          ><br />
                          สลับกับ:
                          <b>{{ item.shiftTransferNewShiftCodeName }}</b
                          ><br />
                          สร้างรายการ <b>{{ item.CREATE_DATE | moment }}</b
                          ><br />
                          เคลื่อนไหวล่าสุด <b>{{ item.LAST_DATE | moment }}</b>
                        </td>
                        <td class="text-center">
                          <v-btn color="gray" class="ma-2" small>
                            {{ item.shiftTransferAppoveStatusName }}
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="request">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">ประวัติการสลับกะ</th>
                        <th class="text-center">สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dataItemFriendApprove"
                        :key="item.shiftTransferId"
                      >
                        <td>
                          <template v-if="item.empFull_NameTH"
                            >เพื่อน : {{ item.empFull_NameTH }} <br
                          /></template>
                          กะ : {{ item.shiftTransferOldShiftCodeName }}<br />
                          <template v-if="item.empFull_NameTH_Friend"
                            >{{ item.empFull_NameTH_Friend }} <br
                          /></template>
                          กะ : {{ item.shiftTransferNewShiftCodeName }}
                        </td>
                        <td class="text-center">
                          <v-btn
                            v-if="
                              item.shiftTransferFriendAppoveStatus == 'waiting'
                            "
                            color="warning"
                            class="ma-2"
                            small
                            dark
                            @click="updateStatus(item, 'approve')"
                          >
                            อนุมัติ
                          </v-btn>
                          <v-btn
                            v-if="
                              item.shiftTransferFriendAppoveStatus == 'waiting'
                            "
                            color="red"
                            class="ma-2"
                            small
                            dark
                            @click="updateStatus(item, 'cancel')"
                          >
                            ยกเลิก
                          </v-btn>
                          <v-btn
                            v-if="
                              item.shiftTransferFriendAppoveStatus != 'waiting'
                            "
                            color="gray"
                            class="ma-2"
                            small
                          >
                            {{ item.shiftTransferFriendAppoveStatusName }}
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="header">
                <v-tabs v-model="tabs2" fixed-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab
                    href="#waiting"
                    class="primary--text"
                    v-if="profile.positionLevelOrderNumber !== '1'"
                  >
                    <v-icon>mdi-clock</v-icon>รออนุมัติ
                    <v-badge
                      v-if="dataICountItemApprove > 0"
                      color="red"
                      :content="dataICountItemApprove"
                    >
                    </v-badge>
                  </v-tab>
                  <v-tab href="#history_header" class="primary--text">
                    <v-icon>mdi-file-document</v-icon> ประวัติ
                  </v-tab>
                </v-tabs>
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="shiftTypeSearch"
                            :items="itemsShiftType"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="ประเภทสลับกะ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="ShiftTransferStatusSearch"
                            :items="itemShiftTransferAppoveStatus"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="สถานะอนุมัติ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือน"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปี"
                            class="ma-2"
                          ></v-select>
                          <v-text-field
                            label="ชื่อพนักงาน"
                            v-model="employeeName"
                            clearable
                            clear-icon="mdi-close-circle"
                            outlined
                            counter="100"
                            maxlength="30"
                            required
                          ></v-text-field>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="
                              getDataHeaderApproveWaiting(),
                                getDataHeaderApprove()
                            "
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-tabs-items v-model="tabs2">
                  <v-tab-item value="waiting">
                    <v-simple-table height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-center">ประวัติการสลับกะ</th>
                            <th class="text-center">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in dataItemApproveWaiting"
                            :key="item.shiftTransferId"
                          >
                            <td>
                              ประเภท : <b>{{ item.shiftTransferTypeName }}</b>
                              <br />
                              โดย : <b>{{ item.empFull_NameTH }}</b> <br />
                              <template v-if="item.empFull_NameTH_Friend"
                                >เพื่อน : {{ item.empFull_NameTH_Friend }}<br
                              /></template>
                              กะ <b>{{ item.shiftTransferOldShiftCodeName }}</b
                              ><br />
                              สลับกับ
                              <b>{{ item.shiftTransferNewShiftCodeName }}</b
                              ><br />
                              สร้างรายการ <b>{{ item.CREATE_DATE | moment }}</b
                              ><br />
                              เคลื่อนไหวล่าสุด
                              <b>{{ item.LAST_DATE | moment }}</b>
                            </td>
                            <td class="text-center">
                              <v-btn
                                v-if="
                                  (item.shiftTransferAppoveStatus ==
                                    'waiting' &&
                                    item.shiftTransferFriendAppoveStatus ==
                                      'approve' &&
                                    item.shiftTransferType == 'friend') ||
                                  (item.shiftTransferType == 'self' &&
                                    item.shiftTransferFriendAppoveStatus ==
                                      'waiting') ||
                                  (item.shiftTransferType == 'shift' &&
                                    item.shiftTransferFriendAppoveStatus ==
                                      'waiting')
                                "
                                color="red"
                                class="ma-2"
                                small
                                dark
                                @click="getInfo(item)"
                              >
                                <v-icon>mdi-alert</v-icon> จัดการ
                              </v-btn>

                              <v-btn
                                v-if="
                                  item.shiftTransferAppoveStatus == 'waiting' &&
                                  item.shiftTransferFriendAppoveStatus ==
                                    'waiting' &&
                                  item.shiftTransferType == 'friend'
                                "
                                color="gray"
                                class="ma-2"
                                small
                              >
                                รอเพื่อนอนุมัติ
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item value="history_header">
                    <v-simple-table height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-center">ประวัติการสลับกะ</th>
                            <th class="text-center">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in dataItemApprove"
                            :key="item.shiftTransferId"
                          >
                            <td>
                              ประเภท : <b>{{ item.shiftTransferTypeName }}</b>
                              <br />
                              โดย : <b>{{ item.empFull_NameTH }}</b> <br />
                              <template v-if="item.empFull_NameTH_Friend"
                                >เพื่อน : {{ item.empFull_NameTH_Friend }} ({{
                                  item.shiftTransferFriendAppoveStatus
                                }})<br
                              /></template>
                              กะ <b>{{ item.shiftTransferOldShiftCodeName }}</b
                              ><br />
                              สลับกับ
                              <b>{{ item.shiftTransferNewShiftCodeName }}</b
                              ><br />
                              สร้างรายการ <b>{{ item.CREATE_DATE | moment }}</b
                              ><br />
                              เคลื่อนไหวล่าสุด
                              <b>{{ item.LAST_DATE | moment }}</b>
                            </td>
                            <td class="text-center">
                              <v-btn color="gray" class="ma-2" small>
                                {{ item.shiftTransferAppoveStatusName }}
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-tab-item>
              <v-tab-item value="verifyheader">
                <v-tabs  v-model="tabs3" fixed-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#subwaiting" class="primary--text">
                    <v-icon>mdi-clock</v-icon>รออนุมัติ
                    <v-badge
                      v-if="dataICountItemApproveSub > 0"
                      color="red"
                      :content="dataICountItemApproveSub"
                    >
                    </v-badge>
                  </v-tab>
                  <v-tab href="#history_subheader" class="primary--text">
                    <v-icon>mdi-file-document</v-icon> ประวัติ
                  </v-tab>
                </v-tabs>
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel v-for="(item, i) in itemPanel" :key="i">
                    <v-expansion-panel-header>ค้นหา</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="shiftTypeSearch"
                            :items="itemsShiftType"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="ประเภทสลับกะ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="ShiftTransferStatusSearch"
                            :items="itemShiftTransferAppoveStatus"
                            item-text="name"
                            item-value="value"
                            return-object
                            single-line
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="สถานะอนุมัติ"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="month"
                            :items="monthNameTH"
                            dense
                            outlined
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle"
                            label="เดือน"
                            class="ma-2"
                          ></v-select>
                          <v-select
                            v-model="year"
                            :items="yearsNumber"
                            dense
                            outlined
                            hide-details
                            label="ปี"
                            class="ma-2"
                          ></v-select>
                          <v-text-field
                            label="ชื่อพนักงาน"
                            v-model="employeeName"
                            clearable
                            clear-icon="mdi-close-circle"
                            outlined
                            counter="100"
                            maxlength="30"
                            required
                          ></v-text-field>
                          <v-btn
                            block
                            elevation="2"
                            color="info"
                            text
                            @click="
                              getDataHeaderApproveWaiting(),
                                getDataHeaderApprove()
                            "
                          >
                            <v-icon left>mdi-calendar-search</v-icon>
                            ค้นหา
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-tabs-items v-model="tabs3">
                  <v-tab-item value="subwaiting">
                    <v-simple-table height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-center">ประวัติการสลับกะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in dataItemApproveWaitingSub"
                            :key="item.shiftTransferId"
                          >
                            <td>
                              ประเภท : <b>{{ item.shiftTransferTypeName }}</b>
                              <br />
                              โดย : <b>{{ item.empFull_NameTH }}</b> <br />
                              <template v-if="item.empFull_NameTH_Friend"
                                >เพื่อน : {{ item.empFull_NameTH_Friend }}<br
                              /></template>
                              กะ <b>{{ item.shiftTransferOldShiftCodeName }}</b
                              ><br />
                              สลับกับ
                              <b>{{ item.shiftTransferNewShiftCodeName }}</b
                              ><br />
                              สร้างรายการ <b>{{ item.CREATE_DATE | moment }}</b
                              ><br />
                              เคลื่อนไหวล่าสุด
                              <b>{{ item.LAST_DATE | moment }}</b>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                  <v-tab-item value="history_subheader">
                    <v-simple-table height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-center">ประวัติการสลับกะ</th>
                            <th class="text-center">สถานะ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in dataItemApproveSub"
                            :key="item.shiftTransferId"
                          >
                            <td>
                              ประเภท : <b>{{ item.shiftTransferTypeName }}</b>
                              <br />
                              โดย : <b>{{ item.empFull_NameTH }}</b> <br />
                              <template v-if="item.empFull_NameTH_Friend"
                                >เพื่อน : {{ item.empFull_NameTH_Friend }} ({{
                                  item.shiftTransferFriendAppoveStatus
                                }})<br
                              /></template>
                              กะ <b>{{ item.shiftTransferOldShiftCodeName }}</b
                              ><br />
                              สลับกับ
                              <b>{{ item.shiftTransferNewShiftCodeName }}</b
                              ><br />
                              สร้างรายการ <b>{{ item.CREATE_DATE | moment }}</b
                              ><br />
                              เคลื่อนไหวล่าสุด
                              <b>{{ item.LAST_DATE | moment }}</b>
                            </td>
                            <td class="text-center">
                              <v-btn color="gray" class="ma-2" small>
                                {{ item.shiftTransferAppoveStatusName }}
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-tab-item>
            </v-tabs-items>
            <v-dialog v-model="dialogApprove">
              <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                  <v-col class="text-right pb-0 pt-0 pr-0">
                    <v-icon color="#173053" @click="dialogApprove = false"
                      >mdi-close-circle</v-icon
                    >
                  </v-col>
                </v-card-title>
                <v-card-title class="pa-0 ml-6 mb-2">
                  <span class="headline">หมายเหตุ</span>
                </v-card-title>
                <v-card-text>
                  <v-textarea
                    v-model="formUpdate.shiftTransferRemarkApprove"
                    maxlength="100"
                    rows="3"
                    row-height="25"
                    outlined
                    :rules="nameRules"
                    clearable
                    clear-icon="mdi-close-circle"
                    label="หมายเหตุ"
                  ></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    v-if="
                      (formUpdate.shiftTransferAppoveStatus == 'waiting' &&
                        formUpdate.shiftTransferFriendAppoveStatus ==
                          'approve' &&
                        formUpdate.shiftTransferType == 'friend') ||
                      (formUpdate.shiftTransferType == 'self' &&
                        formUpdate.shiftTransferFriendAppoveStatus ==
                          'waiting') ||
                      (formUpdate.shiftTransferType == 'shift' &&
                        formUpdate.shiftTransferFriendAppoveStatus == 'waiting')
                    "
                    color="red"
                    elevation="2"
                    dark
                    @click="
                      headerApproveTransfer(formUpdate, 'unapprove'),
                        (dialogApprove = false)
                    "
                  >
                    ไม่อนุมัติ
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="
                      (formUpdate.shiftTransferAppoveStatus == 'waiting' &&
                        formUpdate.shiftTransferFriendAppoveStatus ==
                          'approve' &&
                        formUpdate.shiftTransferType == 'friend') ||
                      (formUpdate.shiftTransferType == 'self' &&
                        formUpdate.shiftTransferFriendAppoveStatus ==
                          'waiting') ||
                      (formUpdate.shiftTransferType == 'shift' &&
                        formUpdate.shiftTransferFriendAppoveStatus == 'waiting')
                    "
                    color="success"
                    elevation="2"
                    dark
                    @click="
                      headerApproveTransfer(formUpdate, 'approve'),
                        (dialogApprove = false)
                    "
                  >
                    อนุมัติ
                  </v-btn>
                </v-card-actions>
                <v-card-actions>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
// import VuetifyLogo from '../logo'
export default {
  data () {
    return {
      dialogForm: false,
      tab: 'shift_friend',
      tabs: 'list1',
      tabs2: 'waiting',
      tabs3: 'subwaiting',
      panel1: [],
      panel: [],
      itemPanel1: 1,
      itemPanel: 1,
      dialogApprove: false,
      form: {
        shiftTransferType: '',
        empCode: '',
        userLineuserId: '',
        empCodeFriend: '',
        userLineuserIdFriend: '',
        shiftTransferOldYear: '',
        shiftTransferOldMonth: '',
        shiftTransferOldDay: '',
        shiftTransferOldShiftCode: '',
        shiftTransferNewYear: '',
        shiftTransferNewMonth: '',
        shiftTransferNewDay: '',
        shiftTransferNewShiftCode: '',
        shiftTransferRemark: '-'
      },
      formUpdate: {
        shiftTransferRemarkApprove: '-'
      },
      nameRules: [(v) => !!v || 'Input is required'],
      empCode: '',
      profile: [],
      dataItemShiftsFriend: [],
      dataItemShift: [],
      dataItemShiftTransfer: [],
      dataItemFriendApprove: [],
      dataItemApproveWaiting: [],
      dataItemApproveWaitingSub: [],
      dataItemApprove: [],
      dataItemApproveSub: [],
      dataItemHeader: [],
      dataItemSubApprove: [],
      dataItemSubHeader: [],
      dataICountItemFriendApprove: 0,
      dataICountItemApprove: 0,
      dataICountItemApproveSub: 0,
      selectFriend: '',
      selectShiftFriend: '',
      shiftDay: '',
      item_Info: [],
      dataItem: [],
      dataShiftItem: [],
      dataShiftSelf: [],
      dataMasShift: [],
      masShiftTypeName: '',
      dataItemTeam: [],
      imageUrlBack: '',
      imageHeadHRM: '',
      shifttem: [],
      shiftDaytem: [],
      dataReportMonth: [],
      empFull_NameTH: '',
      year: '',
      month: '',
      day: '',
      shiftTypeSearch: '',
      ShiftTransferStatusSearch: '',
      employeeName: '',
      dataReady: false,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      currentMorDay: '',
      remarkRules: [(v) => !!v || 'โปรดใส่หมายเหตุ..'],
      itemsShiftType: [
        { name: 'สลับกะ', value: 'self' },
        { name: 'สลับวันทำงาน', value: 'shift' },
        { name: 'สลับกะกับเพื่อน', value: 'friend' }
      ],
      itemShiftTransferAppoveStatus: [
        { name: 'รออนุมัติ', value: 'waiting' },
        { name: 'อนุมัติ', value: 'approve' },
        { name: 'ไม่อนุมัติ', value: 'unapprove' }
      ]
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.currentMorDay = moment().add(1, 'days').format('YYYY-MM-DD')
    this.year = moment().format('YYYY')
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.reloadData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async itemInfo (item) {
      this.item_Info = item
      this.item_Info.masShiftTypeNameDay =
        'DAY: ' + item.shiftDay + ' [' + item.masShiftTypeName + ']'
      this.form.empCodeFriend = null
      this.form.shiftTransferNewShiftCode = null
      this.getDataSelf(item)
    },
    getInfo (item) {
      this.formUpdate = []
      console.log('item', item)
      this.dialogApprove = true
      this.formUpdate = item
      this.formUpdate.shiftTransferRemarkApprove = '-'
    },
    async clearForm (item) {
      this.form.empCodeFriend = null
      this.form.shiftTransferNewShiftCode = null
    },
    async reloadData () {
      this.dataReady = true
      if (this.profile) {
        await this.getDataShift()
        await this.getDataMasShift()
        await this.getDataFrriendRequest()
        await this.getDataHeaderApproveWaiting()
        await this.getDataSubHeaderApproveWaiting()
        await this.getDataHeaderApprove()
        await this.getDataSubHeaderApprove()

        await this.getDataShiftTransfer()
        await this.getEmployeeTeam()
        await this.getEmployeeHeader()
      } else {
        this.$router.push('/Liff/home')
      }

      this.dataReady = false
    },
    async getDataShiftTransfer () {
      this.dataItemShiftTransfer = []

      this.shiftTypeSearch = this.shiftTypeSearch ? this.shiftTypeSearch : null
      this.ShiftTransferStatusSearch = this.ShiftTransferStatusSearch
        ? this.ShiftTransferStatusSearch
        : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var shiftTypeSearch =
        this.shiftTypeSearch !== null
          ? '&shiftTransferType=' + this.shiftTypeSearch
          : ''
      var ShiftTransferStatusSearch =
        this.ShiftTransferStatusSearch !== null
          ? '&shiftTransferAppoveStatus=' + this.ShiftTransferStatusSearch
          : ''
      var monthSearch =
        this.month !== null
          ? '&shiftTransferNewMonth=' + this.getMonthThToINT(this.month)
          : ''

      var url =
        '/shift_transfer/get?empCode=' +
        this.profile.empCode +
        '&shiftTransferNewYear=' +
        this.year +
        monthSearch +
        shiftTypeSearch +
        ShiftTransferStatusSearch

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then(async (response) => {
          this.dataReady = false
          // console.log('getDataShiftTransfer', response.data)
          this.dataItemShiftTransfer = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataShift (month) {
      this.dataItemShift = []
      var monthSearh = month
        ? this.getMonthThToINT(month)
        : moment().format('MM')
      this.year = this.year ? this.year : moment().format('YYYY')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeShiftMonth?empCode=' +
            this.profile.empCode +
            '&shiftMonth=' +
            monthSearh +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItemShift = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = false
        })
    },
    async getEmployeeTeam () {
      this.dataItemTeam = []
      axios
        .get(
          this.DNS_IP +
            '/system_user/getTeam?masDepartmentCode=' +
            this.profile.masDepartmentCode +
            '&empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then((response) => {
          this.dataReady = false
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.empFull_NameTH
              s.value =
                d.empCode + '#' + d.userLineuserId + '#' + d.empFull_NameTH
              this.dataItemTeam.push(s)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getEmployeeHeader () {
      this.dataItemHeader = []
      if (this.profile.positionHeader) {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/approve_permission/get?empCode=' +
              this.profile.empCode,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            this.dataReady = false
            this.dataItemHeader = response.data[0]
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = false
            console.log(error)
          })
      }
    },
    async getDataShiftFriend (data) {
      var dataSplit = data.split('#')
      console.log('getDataShiftFriend', dataSplit)
      this.dataItemShiftsFriend = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpFriendCodeAftertoday?empCode=' +
            dataSplit[0]
        )
        .then(async (response) => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              d.text = 'DAY: ' + d.shiftDay + ' [' + d.masShiftTypeName + ']'
              // d.value = d.masShiftTypeCode + '#' + d.shiftDay
              d.value =
                d.masShiftTypeCode +
                '#' +
                d.shiftDay +
                '#' +
                dataSplit[1] +
                '#' +
                dataSplit[2] +
                '#' +
                d.masShiftTypeName
              this.dataItemShiftsFriend.push(d)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataSelf (item) {
      this.dataShiftSelf = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeAftertoday?empCode=' +
            this.profile.empCode +
            '&shiftYear=' +
            item.shiftYear +
            '&shiftMonth=' +
            item.shiftMonth +
            '&shiftDay=' +
            item.shiftDay
        )
        .then((response) => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              d.text = 'DAY: ' + d.shiftDay + ' [' + d.masShiftTypeName + ']'
              d.value =
                d.masShiftTypeCode +
                '#' +
                d.shiftDay +
                '#' +
                this.profile.userLineuserId +
                '#' +
                this.profile.empFull_NameTH +
                '#' +
                d.masShiftTypeName
              this.dataShiftSelf.push(d)
            }
          }
        })
    },
    async getDataMasShift () {
      this.dataMasShift = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_shift_type/get"
        )
        .then((response) => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              if (d.masShiftTypeCode !== 'H') {
                d.text = d.masShiftTypeName
                d.value =
                  d.masShiftTypeCode +
                  '#' +
                  this.profile.userLineuserId +
                  '#' +
                  this.profile.empFull_NameTH
                this.dataMasShift.push(d)
              }
            }
          }
        })
    },
    async getDataFrriendRequest () {
      this.dataItemFriendApprove = []
      this.dataICountItemFriendApprove = 0
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_transfer/getDataApproveWaiting?empCode=' +
            this.profile.empCode
        )
        .then((response) => {
          this.dataReady = false
          // let rs = response.data
          const rs = response.data.map((item) => {
            if (item.shiftTransferFriendAppoveStatus === 'waiting') {
              return item
            }
          })
          var data = rs.filter(function (element) {
            return element !== 'waiting' && element !== undefined
          })
          this.dataICountItemFriendApprove = data.length
          this.dataItemFriendApprove = data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getDataHeaderApproveWaiting () {
      this.dataItemApproveWaiting = []
      this.dataICountItemApprove = 0

      this.shiftTypeSearch = this.shiftTypeSearch ? this.shiftTypeSearch : null
      this.employeeName = this.employeeName ? this.employeeName : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var shiftTypeSearch =
        this.shiftTypeSearch !== null
          ? '&shiftTransferType=' + this.shiftTypeSearch
          : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''
      var monthSearch =
        this.month !== null
          ? '&shiftTransferNewMonth=' + this.getMonthThToINT(this.month)
          : ''

      var url =
        '/shift_transfer/get?empCodeApprove=' +
        this.profile.empCode +
        '&shiftTransferAppoveStatus=waiting&shiftTransferNewYear=' +
        this.year +
        monthSearch +
        shiftTypeSearch +
        employeeName

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then((response) => {
          this.dataReady = false
          this.dataICountItemApprove = response.data.length
          this.dataItemApproveWaiting = response.data

          if (response.data.length > 0) {
            this.tabs = 'header'
          }
        })

        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getDataHeaderApprove () {
      this.dataItemApprove = []

      this.shiftTypeSearch = this.shiftTypeSearch ? this.shiftTypeSearch : null
      this.employeeName = this.employeeName ? this.employeeName : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')
      this.ShiftTransferStatusSearch = this.ShiftTransferStatusSearch
        ? this.ShiftTransferStatusSearch
        : null

      var shiftTypeSearch =
        this.shiftTypeSearch !== null
          ? '&shiftTransferType=' + this.shiftTypeSearch
          : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''
      var monthSearch =
        this.month !== null
          ? '&shiftTransferNewMonth=' + this.getMonthThToINT(this.month)
          : ''
      var ShiftTransferStatusSearch =
        this.ShiftTransferStatusSearch !== null
          ? '&shiftTransferAppoveStatus=' + this.ShiftTransferStatusSearch
          : ''
      var url =
        '/shift_transfer/getDataHeaderApproveWaiting?empCodeApprove=' +
        this.profile.empCode +
        '&shiftTransferNewYear=' +
        this.year +
        monthSearch +
        shiftTypeSearch +
        ShiftTransferStatusSearch +
        employeeName

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then((response) => {
          this.dataReady = false
          this.dataItemApprove = response.data
        })

        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getDataSubHeaderApproveWaiting () {
      this.dataItemApproveWaitingSub = []
      this.dataICountItemApproveSub = 0

      this.shiftTypeSearch = this.shiftTypeSearch ? this.shiftTypeSearch : null
      this.employeeName = this.employeeName ? this.employeeName : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var shiftTypeSearch =
        this.shiftTypeSearch !== null
          ? '&shiftTransferType=' + this.shiftTypeSearch
          : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''
      var monthSearch =
        this.month !== null
          ? '&shiftTransferNewMonth=' + this.getMonthThToINT(this.month)
          : ''

      var url =
        '/shift_transfer/get?empCodeVerify=' +
        this.profile.empCode +
        '&shiftTransferAppoveStatus=waiting&shiftTransferNewYear=' +
        this.year +
        monthSearch +
        shiftTypeSearch +
        employeeName

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then((response) => {
          this.dataReady = false
          this.dataICountItemApproveSub = response.data.length
          this.dataItemApproveWaitingSub = response.data
        })

        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getDataSubHeaderApprove () {
      this.dataItemApproveSub = []

      this.shiftTypeSearch = this.shiftTypeSearch ? this.shiftTypeSearch : null
      this.employeeName = this.employeeName ? this.employeeName : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : moment().format('YYYY')
      this.ShiftTransferStatusSearch = this.ShiftTransferStatusSearch
        ? this.ShiftTransferStatusSearch
        : null

      var shiftTypeSearch =
        this.shiftTypeSearch !== null
          ? '&shiftTransferType=' + this.shiftTypeSearch
          : ''
      var employeeName =
        this.employeeName !== null
          ? '&empFull_NameTH=' + this.employeeName
          : ''
      var monthSearch =
        this.month !== null
          ? '&shiftTransferNewMonth=' + this.getMonthThToINT(this.month)
          : ''
      var ShiftTransferStatusSearch =
        this.ShiftTransferStatusSearch !== null
          ? '&shiftTransferAppoveStatus=' + this.ShiftTransferStatusSearch
          : ''
      var url =
        '/shift_transfer/getDataSubHeaderApproveWaiting?empCodeVerify=' +
        this.profile.empCode +
        '&shiftTransferNewYear=' +
        this.year +
        monthSearch +
        shiftTypeSearch +
        ShiftTransferStatusSearch +
        employeeName

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url
        )
        .then((response) => {
          this.dataReady = false
          this.dataItemApproveSub = response.data
        })

        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async saveShift (shiftTranferType, form) {
      if (form !== '') {
        if (form.shiftTransferNewShiftCode !== null) {
          // console.log('add')
          // this.reloadData()
          await this.addData(shiftTranferType, form)
          await this.setUpBeforeSendLine(shiftTranferType, form)
          await this.reloadData()
          await this.closeDialog()
          this.dialogForm = false
        } else {
          this.$swal('ข้อมูลไม่ถูกต้อง', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
        }
      } else {
        this.$swal('ข้อมูลไม่ถูกต้อง', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
      }
    },
    async addData (shiftTranferType, form) {
      var shiftSplit = form.shiftTransferNewShiftCode.split('#')
      var newDay = parseInt(shiftSplit[1])
      var newShiftCode = shiftSplit[0]

      if (shiftTranferType === 'friend') {
        var empCodeFriendValueSplit = form.empCodeFriend.split('#')
        var empCodeFriend = empCodeFriendValueSplit[0]
        var userLineuserIdFriend = empCodeFriendValueSplit[1]
      }
      let dt = {
        empCode: this.profile.empCode,
        empCodeFriend: shiftTranferType === 'friend' ? empCodeFriend : null,
        userLineuserId: this.profile.userLineuserId,
        userLineuserIdFriend:
          shiftTranferType === 'friend' ? userLineuserIdFriend : null,
        shiftTransferOldYear: this.item_Info.shiftYear,
        shiftTransferOldMonth: this.item_Info.shiftMonth,
        shiftTransferOldDay: this.item_Info.shiftDay,
        shiftTransferOldShiftCode: this.item_Info.shiftCode,
        shiftTransferNewYear: this.item_Info.shiftYear,
        shiftTransferNewMonth: this.item_Info.shiftMonth,
        shiftTransferNewDay:
          shiftTranferType === 'shift' ? this.item_Info.shiftDay : newDay,
        shiftTransferNewShiftCode: newShiftCode,
        shiftTransferRemark: form.shiftTransferRemark,
        shiftTransferType: shiftTranferType,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName
      }
      // console.log('dt', dt)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_transfer/add",
          dt
        )
        .then(async (response) => {
          this.form = []
          this.form.shiftTransferRemark = '-'
          this.dialogForm = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.form = []
          console.log('error function addDataGlobal : ', error)
        })
    },
    async setUpBeforeSendLine (shiftTranferType, form) {
      var shiftSplit = form.shiftTransferNewShiftCode.split('#')
      var newDay = parseInt(shiftSplit[1])
      var newShiftCode = shiftSplit[0]
      var newShiftName = shiftSplit[2]

      if (form.empCodeFriend) {
        var empCodeFriendValueSplit = form.empCodeFriend.split('#')
        var userLineuserIdFriend = empCodeFriendValueSplit[1]
        var empNameFriend = empCodeFriendValueSplit[2]
      }

      let ds = {
        userLineuserId: this.profile.userLineuserId,
        userLineuserIdFriend:
          shiftTranferType === 'friend' ? userLineuserIdFriend : null,
        empName: this.profile.empFull_NameTH,
        empNameFriend: shiftTranferType === 'friend' ? empNameFriend : null,
        shiftTransferOldYear: this.item_Info.shiftYear,
        shiftTransferOldMonth: this.item_Info.shiftMonth,
        shiftTransferOldDay: this.item_Info.shiftDay,
        shiftTransferOldShiftCode: this.item_Info.shiftCode,
        shiftTransferOldShiftName: this.item_Info.masShiftTypeName,
        shiftTransferNewYear: this.item_Info.shiftYear,
        shiftTransferNewMonth: this.item_Info.shiftMonth,
        shiftTransferNewDay:
          shiftTranferType === 'shift' ? this.item_Info.shiftDay : newDay,
        shiftTransferNewShiftCode: newShiftCode,
        shiftTransferNewShiftName: newShiftName,
        shiftTransferRemark: form.shiftTransferRemark,
        shiftTransferType: shiftTranferType
      }
      if (shiftTranferType === 'self') {
        await this.setUpFlexBeforeSendLineSelf(
          ds,
          'ขออนุมัติสลับวันทำงาน',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2F%E0%B8%AA%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B0%E0%B8%95%E0%B8%99%E0%B9%80%E0%B8%AD%E0%B8%87.png?alt=media'
        )
        await this.setUpFlexBeforeSendLineSelfHeaderRequest(
          ds,
          'ขออนุมัติสลับวันทำงาน',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2F%E0%B8%AA%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B0%E0%B8%95%E0%B8%99%E0%B9%80%E0%B8%AD%E0%B8%87.png?alt=media'
        )
      }
      if (shiftTranferType === 'shift') {
        await this.setUpFlexBeforeSendLineShift(
          ds,
          'ขออนุมัติเปลี่ยนกะ',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2F%E0%B8%AA%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B0%E0%B8%95%E0%B8%99%E0%B9%80%E0%B8%AD%E0%B8%87.png?alt=media'
        )
        await this.setUpFlexBeforeSendLineSelfHeaderRequest(
          ds,
          'ขออนุมัติเปลี่ยนกะ',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2F%E0%B8%AA%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B0%E0%B8%95%E0%B8%99%E0%B9%80%E0%B8%AD%E0%B8%87.png?alt=media'
        )
      }
      if (shiftTranferType === 'friend') {
        await this.setUpFlexBeforeSendLineMe(
          ds,
          'ขออนุมัติสลับกะ',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20685.png?alt=media'
        )
        await this.setUpFlexBeforeSendLineFriend(
          ds,
          'ขออนุมัติสลับกะ',
          'ขออนุมัติ',
          'f56600',
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20685.png?alt=media'
        )
      }
    },
    async setUpFlexBeforeSendLineSelf (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineSelfHeaderRequest (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(
        payload,
        this.dataItemHeader.userLineuserId_approve
      )
    },
    async setUpFlexBeforeSendLineShift (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: headstatus,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineShiftHeaderRequest (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: headstatus,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับวันทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(
        payload,
        this.dataItemHeader.userLineuserId_approve
      )
    },
    async setUpFlexBeforeSendLineMe (item, headstatus, status, color, imageUrl) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empNameFriend,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineFriend (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ได้รับคำขอสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]

      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserIdFriend)
    },
    async updateStatus (dt, status) {
      this.$swal({
        title: 'ยืนยันทำรายการ ' + status + ' ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#07ab0a',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            shiftTransferFriendAppoveStatus: status,
            LAST_USER: this.profile.userName
          }

          if (status === 'cancel') {
            ds.shiftTransferAppoveStatus = 'unapprove'
          }

          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/shift_transfer/edit/" + dt.shiftTransferId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              await this.setUpBeforeSendLineApproveFriend(dt, status)
              await this.reloadData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          this.dataReady = false
          console.log('error : ', error)
        })
    },
    async headerApproveTransfer (item, status) {
      var statusName =
        status === 'approve'
          ? 'อนุมัติ'
          : status === 'unapprove'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.dataReady = true
      let ds1 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferOldDay,
        shiftMonth: item.shiftTransferOldMonth,
        shiftYear: item.shiftTransferOldYear,
        shiftCode: item.shiftTransferNewShiftCode
      }

      let ds2 = {
        empCode:
          item.empCodeFriend !== null ? item.empCodeFriend : item.empCode,
        shiftDay: item.shiftTransferNewDay,
        shiftMonth: item.shiftTransferNewMonth,
        shiftYear: item.shiftTransferNewYear,
        shiftCode: item.shiftTransferOldShiftCode
      }
      // this.dataReady = false
      console.log(ds1)
      console.log(ds2)
      // await this.setUpBeforeSendLine(item, 'อนุมัติสลับกะ', 'อนุมัติ', '017305')
      // await this.setUpBeforeSendLineFriend(item, 'อนุมัติสลับกะ', 'อนุมัติ', '017305')

      this.$swal({
        title: 'ยืนยันทำรายการ ' + statusName + ' ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#07ab0a',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          // console.log(result)
          await this.updateShiftTransfer(ds2, status)
          await this.updateShiftTransfer(ds1, status)
          await this.getCheckIn(ds1, ds2, item, status)
        })
        .catch((error) => {
          this.dataReady = false
          console.log('error : ', error)
        })
    },

    async updateShiftTransfer (ds, status) {
      if (status !== 'unapprove') {
        // console.log(this.DNS_IP + 'shift_transfer/updateShiftTransfer')
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/shift_transfer/updateShiftTransfer",
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            console.log(response)
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
          })
      }
    },
    async getCheckIn (ds1, ds2, item, status) {
      if (status !== 'unapprove') {
        this.empShift01 = []
        this.empShift02 = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/shift_import/get?empCode=' +
              ds1.empCode +
              '&shiftMonth=' +
              ds1.shiftMonth +
              '&shiftYear=' +
              ds1.shiftYear +
              '&shiftDay=' +
              ds1.shiftDay
          )
          .then(async (response) => {
            this.empShift01 = response.data[0]
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // console.log(error)
          })
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/shift_import/get?empCode=' +
              ds2.empCode +
              '&shiftMonth=' +
              ds2.shiftMonth +
              '&shiftYear=' +
              ds2.shiftYear +
              '&shiftDay=' +
              ds2.shiftDay
          )
          .then(async (response) => {
            this.empShift02 = response.data[0]
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // console.log(error)
          })
        // console.log('this.empShift01', this.empShift01)
        // console.log('this.empShift02', this.empShift02)
        await this.transferShift(this.empShift02, ds2)
        await this.transferShift(this.empShift01, ds1)
      }
      await this.updateHeaderStatus(item, status)
    },
    async updateHeaderStatus (dt, status) {
      let ds = {
        shiftTransferAppoveStatus: status,
        shiftTransferRemarkApprove: dt.shiftTransferRemarkApprove,
        LAST_USER: this.profile.userName
      }
      if (dt.shiftTransferType === 'self' || 'shift') {
        ds.shiftTransferFriendAppoveStatus = status
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_transfer/edit/" + dt.shiftTransferId,
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          await this.setUpBeforeSendLineHeader(dt, status)
          await this.reloadData()
          this.dataReady = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async transferShift (item, ds) {
      let data = {
        empCode: ds.empCode,
        shiftDay: item.shiftDay,
        shiftMonth: item.shiftMonth,
        shiftYear: item.shiftYear,
        shiftData: moment(
          item.shiftYear + '-' + item.shiftMonth + '-' + item.shiftDay
        ).format('YYYY-MM-DD'),
        shiftCode: item.shiftCode,
        masShiftTypeStartTime: item.masShiftTypeStartTime || null,
        masShiftTypeEndTime: item.masShiftTypeEndTime || null,
        checkInStartStamp: item.checkInStartStamp || null,
        checkInStartLat: item.checkInStartLat || null,
        checkInStartLong: item.checkInStartLong || null,
        checkInEndStamp: item.checkInEndStamp || null,
        checkInEndLat: item.checkInEndLat || null,
        checkInEndLong: item.checkInEndLong || null,
        checkInMapUrl: item.checkInMapUrl || null,
        checkOutMapUrl: item.checkOutMapUrl || null,
        location: item.location || null
      }
      console.log('data', ds.empCode, data)

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/ch_checkin/updateTransfer",
          data
        )
        .then(async (response) => {
          // this.dataReady = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('error function addData : ', error)
          // this.dataReady = false
        })
    },
    async setUpBeforeSendLineHeader (dt, status) {
      // console.log(dt.shiftTransferType)
      // console.log(status)
      var statusmessage = ''
      var color = '017305'
      if (status !== 'approve') {
        statusmessage = 'ไม่'
        color = '800305'
      }

      var imageUrl =
        'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20695.png?alt=media'
      if (status === 'unapprove') {
        imageUrl =
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20699.png?alt=media'
      }

      if (dt.shiftTransferType === 'self') {
        await this.setUpFlexBeforeSendLineSelfHeader(
          dt,
          statusmessage + 'อนุมัติสลับวันทำงาน',
          statusmessage + 'อนุมัติ',
          color,
          imageUrl
        )
      }
      if (dt.shiftTransferType === 'shift') {
        await this.setUpFlexBeforeSendLineSelfHeader(
          dt,
          statusmessage + 'อนุมัติเปลี่ยนกะ',
          statusmessage + 'อนุมัติ',
          color,
          imageUrl
        )
      }
      if (dt.shiftTransferType === 'friend') {
        await this.setUpFlexBeforeSendLineMeHeader(
          dt,
          statusmessage + 'อนุมัติสลับกะ',
          statusmessage + 'อนุมัติ',
          color,
          imageUrl
        )
        await this.setUpFlexBeforeSendLineFriendHeader(
          dt,
          statusmessage + 'อนุมัติสลับกะ',
          statusmessage + 'อนุมัติ',
          color,
          imageUrl
        )
      }
    },
    async setUpFlexBeforeSendLineSelfHeader (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: headstatus,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'กะใหม่ของท่าน' + status,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineMeHeader (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.shiftTransferOldShiftCodeName,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ท่านได้ขออนุมติสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empFull_NameTH_Friend,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.shiftTransferNewShiftCodeName,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'ขอให้เป็นวันที่ดีของท่าน',
                      wrap: true,
                      align: 'center',
                      style: 'italic'
                    }
                  ],
                  margin: '12px'
                }
              ]
            }
          }
        }
      ]
      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineFriendHeader (
      item,
      headstatus,
      status,
      color,
      imageUrl
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: imageUrl,
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.shiftTransferNewShiftCodeName,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ได้รับคำขอสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.shiftTransferOldShiftCodeName,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]

      // U97a2b1814542579b9e5d7c1b891538ab
      // Ue5f7e8597b17161176f32b3056f55790
      // userLineuserId

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserIdFriend)
    },
    async setUpBeforeSendLineApproveFriend (dt, status) {
      // console.log(status)
      var confirmStatus = 'ยืนยัน(รออนุมัติ)'
      var confirmColor = '060296'
      if (status === 'cancel') {
        confirmStatus = 'ยกเลิก'
        confirmColor = '800305'
      }

      await this.setUpFlexBeforeSendLineFriendApproveWaiting(
        dt,
        confirmStatus,
        confirmStatus,
        confirmColor
      )

      if (status === 'approve') {
        await this.setUpFlexBeforeSendLineFriendApproveWaitingHeader(
          dt,
          'ขออนุมัติสลับกะ',
          'ขออนุมัติสลับกะ',
          'f56600'
        )
      }
    },
    async setUpFlexBeforeSendLineFriendApproveWaiting (
      item,
      headstatus,
      status,
      color
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20685.png?alt=media',
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ได้รับคำขอสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empFull_NameTH_Friend,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]

      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(payload, item.userLineuserId)
    },
    async setUpFlexBeforeSendLineFriendApproveWaitingHeader (
      item,
      headstatus,
      status,
      color
    ) {
      var payload = [
        {
          type: 'flex',
          altText: headstatus,
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20685.png?alt=media',
                  size: '70%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำขออสลับกะทำงาน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: status,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferOldShiftCode +
                        ')' +
                        item.shiftTransferOldYear +
                        '-' +
                        item.shiftTransferOldMonth +
                        '-' +
                        item.shiftTransferOldDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      text: 'ขออนุมัติสลับกะกับ',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.empFull_NameTH_Friend,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        '(' +
                        item.shiftTransferNewShiftCode +
                        ')' +
                        item.shiftTransferNewYear +
                        '-' +
                        item.shiftTransferNewMonth +
                        '-' +
                        item.shiftTransferNewDay,
                      wrap: true,
                      align: 'center',
                      color: '#' + color
                    },
                    {
                      type: 'text',
                      wrap: true,
                      align: 'center',
                      text:
                        'วันที่ ' +
                        moment().format('DD') +
                        '/' +
                        moment().format('MM') +
                        '/' +
                        moment().format('YYYY') +
                        ' เวลา ' +
                        moment().format('HH') +
                        ':' +
                        moment().format('mm'),
                      size: '14px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=ShiftsTransfer'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      // await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      await this.sendLinePush(
        payload,
        this.dataItemHeader.userLineuserId_approve
      )
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      // console.log('sendLINEPush', dt)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('linenotify: ', error)
        })
    },
    closeDialog () {
      this.$liff.closeWindow()
    },
    clearSearch () {
      this.shiftTypeSearch = null
      this.ShiftTransferStatusSearch = null
      this.month = null
      this.panel = []
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/ShiftsTransfer.vue